var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-error"},[_c('img',{attrs:{"src":_vm.Erro404,"alt":"erro 404"}}),_c('p',[_vm._v("Página não encontrada.")]),_c('Botao',{attrs:{"label":"Início","callback":_vm.voltarInicio}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }